import styled from 'styled-components';

import { SmallStyled } from 'approot/shared/styles/typography.style';
import { grey7 } from 'approot/shared/styles/colours.style';

export const LessonMaterialSmallText = styled(SmallStyled)`
  color: ${grey7};
  display: block;
`;

export const LessonMaterialTextItalic = styled.span`
  color: ${grey7};
  font-style: italic;
`;
